import { FC } from "react";
import { SanityGraphicItem } from "../../graphql-types";
import { cn, mergeArrays } from "../lib/helpers";
import * as styles from "./InfoGraphic.module.scss";
import InfoGraphicCard from "./InfoGraphicCard";
import InfoGraphicListTitle from "./InfoGraphicListTitle";
import { pageTitleStyle } from "./typography.module.scss";
import CablesBoth from "../images/info-cables-both.svg";
import CablesLeft from "../images/info-cables-left.svg";
import CablesRight from "../images/info-cables-right.svg";

export interface InfoGraphicProps {
  graphicTitle: string;
  graphicLanItems: SanityGraphicItem[];
  graphicStreamItems: SanityGraphicItem[];
  streamathonLabel: string;
  streamathonDate: string;
  lanLabel: string;
  lanDate: string;
}

const InfoGraphic: FC<InfoGraphicProps> = ({
  graphicTitle,
  graphicLanItems,
  graphicStreamItems,
  streamathonLabel,
  streamathonDate,
  lanLabel,
  lanDate,
}) => {
  const graphicItemsDesktop = mergeArrays(graphicLanItems, graphicStreamItems);
  return (
    <div className={styles.root}>
      <div className={cn(pageTitleStyle, styles.graphicTitle)}>
        {graphicTitle}
      </div>
      <div className={styles.mobileOnly}>
        <div className={styles.graphicColumn}>
          <CablesLeft className={cn(styles.imageCables)} />
          <InfoGraphicListTitle
            label={lanLabel}
            date={lanDate}
            color="orange"
          />
          {graphicLanItems.map((item, i) => (
            <InfoGraphicCard key={i} {...item} theme="orange" />
          ))}
        </div>
        <div className={styles.graphicColumn}>
          <CablesRight className={cn(styles.imageCables)} />
          <InfoGraphicListTitle
            label={streamathonLabel}
            date={streamathonDate}
            color="blue"
          />
          {graphicStreamItems.map((item, i) => (
            <InfoGraphicCard key={i} {...item} theme="blue" />
          ))}
        </div>
      </div>
      <div className={cn(styles.graphicRootDesktop)}>
        <CablesBoth className={cn(styles.imageCables)} />
        <InfoGraphicListTitle label={lanLabel} date={lanDate} color="orange" />
        <InfoGraphicListTitle
          label={streamathonLabel}
          date={streamathonDate}
          color="blue"
        />
        {graphicItemsDesktop.map((item, i) => (
          <div key={i} className={styles.graphicCardWrapper}>
            <InfoGraphicCard
              {...item}
              theme={i % 2 === 0 ? "orange" : "blue"}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoGraphic;
